export default __webpack_public_path__ + "static/media/harbor2.d9b9f590.jpg";